/**
 * Check whether the page is in an iframe
 *
 * @returns whether the window is in an iframe
 */
export const IsInIframe = (): boolean => {
  try {
    return window.location !== window.parent.location;
  } catch {
    return false;
  }
};
